import styled from 'styled-components';

const Container = styled.div`
  width: 30rem;
`;

export { Container };
